module.exports = __webpack_public_path__ + "img/wuestenrot_logo.92d1d748.svg";